import React, { forwardRef } from 'react'

import Box, { type BoxProps } from '../box'

// horizontal gutter: 20 on phones, 24 on tablets, 32 on desktops
export const gutterWidth = {
  mobile: '20',
  tablet: '24',
  desktop: '32'
} as const

export type SectionProps = BoxProps

const Section = forwardRef<HTMLElement, SectionProps>((props, ref) => (
  <Box ref={ref} px={gutterWidth} {...props} />
))
Section.displayName = 'Section'

export default Section
